module.exports = "https://trybtryb-legacy.web.app/img/kamna.3a117205.webp";